'use strict';exports.__esModule = true;exports.formatVirtualNumbersOnlyOptions = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatVirtualNumbersOptions = function formatVirtualNumbersOptions(numbers, isRtl, title) {
  var ltrMark = !isRtl ? _react2.default.createElement('span', null, '\u200E') : '';
  return (numbers || []).map(function (item) {
    var label = _react2.default.createElement('span', null, item.ext_target_name, ltrMark, '\xA0-\xA0', item.virtual_number, '\xA0', title);
    return {
      label: label,
      value: item.virtual_number,
      name: item.ext_target_name,
      realtor_id: item.realtor_id };

  });
};

var formatVirtualNumbersOnlyOptions = exports.formatVirtualNumbersOnlyOptions = function formatVirtualNumbersOnlyOptions(numbers) {return numbers.map(function (item) {
    var label = _react2.default.createElement('span', null, item.ext_target_name);
    return {
      label: label,
      value: item.virtual_number,
      name: item.ext_target_name };

  });};exports.default =

formatVirtualNumbersOptions;


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatVirtualNumberOptions.js
// module id = 1305
// module chunks = 0